import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { SadmEntityDisplay } from '@modules/sadm/models/sadm-entity-display';
import { getSadmRoute } from '@modules/sadm/utils/get-sadm-route';
import { Store } from '@ngrx/store';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';
import { selectDepartmentId } from '@shared/store/router/router.selectors';
import { injectActiveClientCode } from '@shared/utils/active-client-code.utils';
import { SadmDocumentShortcutComponent } from '../sadm-document-shortcut/sadm-document-shortcut.component';
import { SadmEntityPreviewComponent } from '../sadm-entity-preview/sadm-entity-preview.component';

@Component({
  selector: 'pxc-sadm-entity-list',
  templateUrl: './sadm-entity-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'grid gap-x-4 gap-y-6 md:grid-cols-2 xl:grid-cols-3',
  },
  imports: [
    TranslocoDirective,
    SadmEntityPreviewComponent,
    RouterLink,
    EmptyStateComponent,
    SadmDocumentShortcutComponent,
  ],
})
export class SadmEntityListComponent {
  readonly items = input<SadmEntityDisplay[]>([]);

  readonly clientCode = injectActiveClientCode();

  private readonly store = inject(Store);
  private readonly departmentId = this.store.selectSignal(selectDepartmentId);

  readonly itemsWithRoute = computed(() =>
    this.items().map((sadmEntity) => ({
      sadmEntity,
      route: getSadmRoute(this.clientCode(), this.departmentId(), sadmEntity.id),
    })),
  );
}
